import React, { useMemo, useState, useEffect } from "react";
import Customtable from "../../helper/Customtable";
import Swal from 'sweetalert2';
import { post } from "../../helper/api_helper"

const Tobacco_product = () => {
    const initialFormState = {
        tobacco_product_id: 0,
        emoji: '',
        tobacco_product_name:'',
        tobacco_product_type_id_fk:'',
        status: '0'
    };

    const [formData, setFormData] = useState(initialFormState);
    const [validated, setValidated] = useState(false);
    const [tobaccoProductList, setTobaccoProductList] = useState([]);
    const [tobaccoProductTypeList, setTobaccoProductTypeList] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const columns = useMemo(
        () => [
            {
                header: 'S.No',
                label_condition: 's_no',
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: 'Actions',
                cell: ({ row }) => (
                    <>
                        <i
                            className="ri-file-edit-fill text-primary cursor-pointer me-2"
                            onClick={() => handleEdit(row)}
                            title="Edit"
                            style={{ fontSize: "18px" }}
                        />
                    </>
                ),
                enableSorting: false,
                enableColumnFilter: false,
            },
            {
                header: 'Tobacco Product Name',
                accessorKey: 'tobacco_product_name',
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: 'Tobacco Product Type Name',
                accessorKey: 'tobacco_product_type_name',
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: 'Emoji',
                accessorKey: 'emoji',
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: 'Status',
                accessorKey: 'status',
                enableColumnFilter: false,
                enableSorting: true,
                label_condition: 'status',
            },
        ],
        []
    );

    const handleEdit = (row) => {

        setFormData({
            tobacco_product_id: row.tobacco_product_id,
            tobacco_product_type_id_fk : row.tobacco_product_type_id_fk,
            tobacco_product_name: row.tobacco_product_name,
            emoji: row.emoji,
            status: row.status
        });
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const showAlert = (icon, title, text, timer = 2000) => {
        Swal.fire({ icon, title, text: text || 'Something went wrong.', timer, showConfirmButton: false });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
            showAlert('error', 'Oops...', 'Please fill in all required fields.');
            setValidated(true);
        } else {
            try {
                setValidated(false);
                const response = await post("/masters/tobacco_product", formData);
                if (response.status === 200) {
                    showAlert('success', 'Saved', response.message);
                    fetchData();
                    setFormData(initialFormState);
                } else {
                    showAlert('error', response.status, response.message);
                }
            } catch (err) {
                showAlert('error', 'Unexpected Error', err.message);
            }
        }
    };

    const handleReset = () => {
        setFormData(initialFormState);
        setValidated(false);
    };

    const fetchData = async () => {
        try {
            const response = await post("/masters/tobacco_product_list");
            if (response.status === 200) {
                setTobaccoProductList(response.data);
            } else {
                showAlert('error', response.status, response.message);
            }
        } catch (err) {
            showAlert('error', 'Unexpected Error', err.message);
        }
    };

    const fetchProductTypeData = async () => {
        try {
            const response = await post("/masters/tobacco_product_type_list");
            if (response.status === 200) {
                setTobaccoProductTypeList(response.data);
            } else {
                showAlert('error', response.status, response.message);
            }
        } catch (err) {
            showAlert('error', 'Unexpected Error', err.message);
        }
    };

    useEffect(() => {
        fetchData();
        fetchProductTypeData();
    }, []);

    return (
        <div className="row">
            <div className="col-lg-3">
                <div className="card">
                    <form noValidate className={validated ? "was-validated" : ""} onSubmit={handleSubmit}>
                    <div className="card-header">
                        <h5 className="card-title mb-0">TOBACCO PRODUCT</h5>
                    </div>
                    <div className="card-body">
                        <div className="row g-3">
                            <div className="col-md-12">
                                <label>Tobacco Product Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="tobacco_product_name"
                                    name="tobacco_product_name"
                                    value={formData.tobacco_product_name}
                                    onChange={handleChange}
                                    required
                                    placeholder="Tobacco Product Name"
                                />
                            </div>
                             <div className="col-md-12">
                                <label>Tobacco Product Type</label>
                                <select
                                    name="tobacco_product_type_id_fk"
                                    className="form-control radius-4 form-select"
                                    value={formData.tobacco_product_type_id_fk}
                                    onChange={handleChange}
                                >
                                    <option value="">Select</option>
                                    {tobaccoProductTypeList.map((tobacco_product_type) => (
                                        <option key={tobacco_product_type.tobacco_product_type_id} value={tobacco_product_type.tobacco_product_type_id}>
                                        {tobacco_product_type.tobacco_product_type_name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-12">
                                <label>Emoji</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="emoji"
                                    name="emoji"
                                    value={formData.emoji}
                                    onChange={handleChange}
                                    required
                                    placeholder="Emoji"
                                />
                            </div>

                            <div className="col-md-12">
                                <label>Status</label>
                                <select
                                    className="form-control radius-8 form-select"
                                    id="status"
                                    name="status"
                                    value={formData.status}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="" disabled>Select</option>
                                    <option value="0">Active</option>
                                    <option value="1">In-Active</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="card-footer">
                        <div className="row">
                        <div className="col-md-12">
                            <button type="submit" className="btn btn-primary btn-sm" style={{ float: "right"}}>SAVE</button>
                            <button type="button" onClick={handleReset} className="btn btn-sm btn-secondary">Clear</button>
                        </div>
                        </div>
                    </div>
                    </form>
                </div>
            </div>
            <div className="col-lg-9">
                <div className="card basic-data-table">
                    <div className="card-header">
                    <h5 className="card-title mb-0">Tobacco Product List</h5>
                    </div>
                    <div className="card-body">
                    <Customtable
                        table_title="Tobacco Product List"
                        columns={columns}
                        data={tobaccoProductList}
                        isGlobalFilter={true}
                        isPagination={true}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        isExportButton={true}
                    />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Tobacco_product;
